

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';
import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';
import { useMutation } from 'react-query';
import { useForm } from 'react-hook-form';
import { CourseSuggestionService } from 'services/common';
import { isUserLoggedIn } from 'utils/authentication';

import Modal from '@core/components/Modal/Modal';
import ActionButton from '../actionbutton/ActionButton';
import TextInput from '@core/components/textinput/TextInput';

import classes from './CourseSuggestion.module.scss';
import { getErrorText } from 'utils/geterrortext';
import RichTextEditor from '../richtexteditor/RichTextEditor';
import TextArea from '../textarea/TextArea';

const CourseSuggestion = ({ type = 'long' }) => {
    const { show, showModal, destroyModal } = UseModal();
    const { toast, ToastContainer } = UseToast();
    const { mutate } = useMutation(CourseSuggestionService, {
        onSuccess: () => {
            toast(
                'Course suggestion submitted successfully.',
                'success'
            );
            destroyModal();
        },
        onError: (error) => {
            toast(
                getErrorText(error),
                'alert'
            );
        }
    });
    const {
        register,
        handleSubmit,
        formState: { errors, isDirty, isValid }
    } = useForm({ mode: 'onChange' });

    const submitForm = (payload) => {
        if (!payload.description) {
            delete payload.description;
        }
        mutate(payload);
    };

    const actionHandler = () => {
        if (isUserLoggedIn())
            showModal();
        else
            toast(
                'Please login before suggesting a course',
                'alert'
            );
    };



    return (
        <>
            {type === 'long' ? (
                <div className='container row d-flex align-items-center justify-content-center'>
                    <div className='col-xxl-10 col-10'>
                        <div className={classes['wrapper-long']}>
                            <h3>Didn’t Find Your Course?</h3>
                            <p>Tell us the course you’re missing. Explain why it matters—your idea could become our next launch.</p>
                            <ActionButton kind='secondary' onClick={() => actionHandler()}>Suggest a Course</ActionButton>
                        </div>
                    </div>
                </div>

            ) : (
                <ActionButton kind='blank' onClick={() => actionHandler()}>Suggest a Course</ActionButton>
            )}
            <Modal
                type={MOBILE_FULLSCREEN}
                show={show}
                header={false}
            >
                <div className={classes['form-wrapper']}>
                    <h4>Suggest a New Course</h4>
                    <p>
                        Have a course in mind that Pharmuni is missing? Tell us
                        the course name and why it matters to you — your
                        feedback helps us build the content you need next.
                    </p>
                    <form onSubmit={handleSubmit(submitForm)} className={classes['subscribe-form']}>
                        <TextInput
                            validation={{
                                required: true
                            }}
                            input={{
                                label: 'Course Title',
                                name: 'title',
                                id: 'title',
                                placeholder: 'Exp. Introduction to Pharamcovigilance'
                            }}
                            errors={errors}
                            register={register}
                        />
                        <TextArea
                            input={{
                                type: 'text',
                                label: 'What do you want to learn from it?',
                                name: 'description',
                                id: 'description',
                            }}
                            errors={errors}
                            register={register}
                        />
                        <div className='d-flex justify-content-center gap-4'>
                            <ActionButton kind='simple' onClick={destroyModal}>Cancel</ActionButton>
                            <ActionButton type="submit" disabled={!isDirty || !isValid}>
                                Submit
                            </ActionButton>
                        </div>

                    </form>
                </div>
            </Modal>
            <ToastContainer />
        </>
    );
}

export default CourseSuggestion;